const ALERT_TITLE = '【新客服消息】在线客服 - 龙珠电竞'
const ALERT_FAVICON_ID = 'support-alert-favicon'
const ALERT_THEME_COLOR = '#f97316'

const alertFavicon = `data:image/svg+xml,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64">
  <rect width="64" height="64" rx="14" fill="#f97316"/>
  <path d="M19 21h26a7 7 0 0 1 7 7v9a7 7 0 0 1-7 7H31l-10 8v-8h-2a7 7 0 0 1-7-7v-9a7 7 0 0 1 7-7z" fill="#fff7ed"/>
  <circle cx="25" cy="32" r="3" fill="#fb923c"/>
  <circle cx="32" cy="32" r="3" fill="#fb923c"/>
  <circle cx="39" cy="32" r="3" fill="#fb923c"/>
</svg>`)}`.replace(/\n/g, '')

let activeKeys = new Set<string>()
let timer: number | undefined
let flashOn = false
let baseTitle = ''
let baseThemeColor = ''

const getThemeColorMeta = () => document.querySelector<HTMLMetaElement>('meta[name="theme-color"]')

const ensureAlertFavicon = () => {
  let link = document.querySelector<HTMLLinkElement>(`#${ALERT_FAVICON_ID}`)
  if (!link) {
    link = document.createElement('link')
    link.id = ALERT_FAVICON_ID
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  link.type = 'image/svg+xml'
  link.href = alertFavicon
}

const removeAlertFavicon = () => {
  document.querySelector(`#${ALERT_FAVICON_ID}`)?.remove()
}

const setOrangeBrowserChrome = (enabled: boolean) => {
  if (enabled) {
    ensureAlertFavicon()
  } else {
    removeAlertFavicon()
  }

  const themeColor = getThemeColorMeta()
  if (themeColor) {
    themeColor.content = enabled ? ALERT_THEME_COLOR : baseThemeColor
  }
}

const startTimer = () => {
  if (timer) return
  baseTitle = document.title
  baseThemeColor = getThemeColorMeta()?.content || ''
  flashOn = false
  timer = window.setInterval(() => {
    flashOn = !flashOn
    document.title = flashOn ? ALERT_TITLE : baseTitle
    setOrangeBrowserChrome(flashOn)
  }, 850)
}

const stopTimer = () => {
  if (timer) window.clearInterval(timer)
  timer = undefined
  flashOn = false
  document.title = baseTitle || document.title
  setOrangeBrowserChrome(false)
}

export const startSupportBrowserAlert = (key: string) => {
  activeKeys.add(key)
  startTimer()
}

export const stopSupportBrowserAlert = (key: string) => {
  activeKeys.delete(key)
  if (activeKeys.size === 0) stopTimer()
}

export const clearSupportBrowserAlerts = () => {
  activeKeys = new Set<string>()
  stopTimer()
}
